<template>
  <div class="content-login-containe">
    <div class="social-network-login">
      <RightPanel />
    </div>
    <div class="intro-izi">
      <LeftPanel />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import RightPanel from "../../../components/rightPanel/RightPanel.vue";
import LeftPanel from "../../../components/leftPanel/LeftPanel.vue";
@Options({
  components: {
    RightPanel,
    LeftPanel
  }
})
export default class Content extends Vue {}
</script>

<style lang="scss">
.content-login-containe {
  height: 100%;
}
.intro-izi,
.social-network-login {
  width: 50%;
  height: 100%;
  background: #ffffff;
  .p-grid {
    width: 100%;
  }
}
.intro-izi {
  float: left;
}
.social-network-login {
  float: right;
}

@media only screen and (max-width: 768px) {
  .intro-izi,
  .social-network-login {
    width: 100%;
    float: none;
    display: block;
  }
}
</style>
